export let hybridspaceAdminDashboardLink = "PW_8vd";
export let hybridspaceManagementLink = "FmMcAb";
export let hybridspaceAnalyticsLink = "CNGMCd";
export default {hybridspaceAdminDashboardLink,hybridspaceManagementLink,hybridspaceAnalyticsLink};